/* Technotrade Unified Estimator — ES5
 * Single source of truth for ALL coverage / consumption / quote calculations.
 *
 * Public API: window.TTEstimator
 */
(function () {
  'use strict';

  function inr(n) {
    if (!isFinite(n) || n < 0) return '0';
    var v = Math.round(n);
    try { return v.toLocaleString('en-IN'); }
    catch (e) {
      var x = v.toString();
      if (x.length <= 3) return x;
      var last3 = x.slice(-3);
      var rest = x.slice(0, -3);
      return rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    }
  }

  function fmt(n, d) {
    if (!isFinite(n)) return '0';
    d = d == null ? 1 : d;
    var p = Math.pow(10, d);
    return Math.round(n * p) / p;
  }

  function sqftToSqm(sqft) { return sqft * 0.0929; }

  function unitFromString(s) {
    s = (s || '').toLowerCase();
    return s.indexOf('litre') >= 0 ? 'litre' : 'kg';
  }

  function packCombo(needed, sizes) {
    if (!sizes || !sizes.length) return [{ size: 1, count: Math.ceil(needed) }];
    var s = sizes.slice().sort(function (a, b) { return b - a; });
    var combo = [];
    var rem = needed;
    for (var i = 0; i < s.length; i++) {
      if (rem <= 0) break;
      var last = (i === s.length - 1);
      var sz = s[i];
      var n = last ? Math.ceil(rem / sz) : Math.floor(rem / sz);
      if (n > 0) {
        combo.push({ size: sz, count: n });
        rem -= n * sz;
      }
    }
    if (combo.length === 0) combo.push({ size: s[s.length - 1], count: 1 });
    return combo;
  }

  function normalizePackSizes(packs) {
    if (!packs || !packs.length) return [];
    if (typeof packs[0] === 'number') return packs;
    var out = [];
    for (var i = 0; i < packs.length; i++) {
      var p = packs[i];
      var sz = p.size || p.weight_kg || 0;
      if (sz >= 1000) sz = sz / 1000;
      if (sz > 0) out.push(sz);
    }
    return out;
  }

  function comboPrice(combo, packs) {
    if (!packs || !packs.length || typeof packs[0] === 'number') return 0;
    var t = 0;
    var ok = true;
    for (var j = 0; j < combo.length; j++) {
      var x = combo[j];
      var f = null;
      for (var i = 0; i < packs.length; i++) {
        var sz = packs[i].size || packs[i].weight_kg || 0;
        if (sz >= 1000) sz = sz / 1000;
        if (Math.abs(sz - x.size) < 0.011) { f = packs[i]; break; }
      }
      if (f && f.price > 0) t += x.count * f.price;
      else ok = false;
    }
    return ok ? t : 0;
  }

  function comboLabel(c, u) {
    var out = [];
    for (var i = 0; i < c.length; i++) {
      out.push(c[i].count + ' × ' + c[i].size + ' ' + u);
    }
    return out.join(' + ');
  }

  function comboTotal(c) {
    var t = 0;
    for (var i = 0; i < c.length; i++) t += c[i].count * c[i].size;
    return t;
  }

  function normalize(raw) {
    raw = raw || {};
    var ctx = {
      productId:    raw.productId || null,
      productTitle: raw.productTitle || '',
      productHandle: raw.productHandle || '',
      vendor:       raw.vendor || '',
      variants:     raw.variants || [],
      pack_sizes:   raw.pack_sizes || null,
      category:     raw.calc_category || raw.category || null,
      formula:      null,
      consumption:  0,
      unit:         'kg',
      refThickness: 0,
      coats:        0,
      minDosage:    0,
      maxDosage:    0,
      optimalDosage: 0,
      dosageRef:    'cement',
      tileSize:     'standard',
      crackWidth:   0,
      jointDims:    null,
      coatingType:  null
    };

    if (raw.calc_mode) ctx.formula = raw.calc_mode;
    else if (raw.coverage_formula) ctx.formula = mapLegacyFormula(raw.coverage_formula);

    if (raw.coverage_value != null && raw.coverage_value !== '') {
      ctx.consumption = parseFloat(raw.coverage_value) || 0;
    } else if (raw.coverage_consumption != null && raw.coverage_consumption !== '') {
      ctx.consumption = parseFloat(raw.coverage_consumption) || 0;
    }

    ctx.unit = raw.coverage_unit || ctx.unit;
    if (raw.application_coats) ctx.coats = parseInt(raw.application_coats, 10) || 0;

    if (!raw.calc_mode && raw.coverage_ref_thickness != null && raw.coverage_ref_thickness !== '') {
      ctx.refThickness = parseFloat(raw.coverage_ref_thickness) || 0;
    }

    if (raw.coverage_min_dosage != null) ctx.minDosage = parseFloat(raw.coverage_min_dosage) || 0;
    if (raw.coverage_max_dosage != null) ctx.maxDosage = parseFloat(raw.coverage_max_dosage) || 0;
    if (raw.coverage_optimal_dosage != null) ctx.optimalDosage = parseFloat(raw.coverage_optimal_dosage) || 0;
    if (raw.coverage_dosage_ref) ctx.dosageRef = raw.coverage_dosage_ref;

    if (raw.tile_size_factor) ctx.tileSize = raw.tile_size_factor;
    if (raw.crack_width_mm != null) ctx.crackWidth = parseFloat(raw.crack_width_mm) || 0;
    if (raw.joint_dims_mm) ctx.jointDims = raw.joint_dims_mm;
    if (raw.coating_type) ctx.coatingType = raw.coating_type;

    return ctx;
  }

  function mapLegacyFormula(legacy) {
    var map = {
      tile_adhesive:         'area_kg_per_mm',
      plaster:               'area_kg',
      slurry_coat:           'area_kg',
      repair_mortar:         'area_kg',
      liquid_membrane:       'area_litre',
      admixture_cement:      'dosage_pct_cement',
      admixture_concrete:    'dosage_per_cum',
      admixture_per_bag:     'dosage_per_bag',
      admixture_dual:        'dosage_dual',
      cement_grout:          'joint_volume',
      expansion_joint_board: 'joint_sheet'
    };
    return map[legacy] || legacy;
  }

  var formulas = {

    area_kg: {
      id: 'area_kg', label: 'Coverage by area (kg)',
      inputs: ['area', 'areaUnit?', 'thickness?', 'coats?', 'wastage?'],
      compute: function (ctx, inp) {
        if (!inp.area || ctx.consumption <= 0) return null;
        var areaSqm = inp.areaUnit === 'sqm' ? inp.area : sqftToSqm(inp.area);
        var coats = inp.coats || ctx.coats || 1;
        var totalKg = ctx.consumption * coats * areaSqm;
        if (ctx.refThickness > 0 && inp.thickness > 0) {
          totalKg *= (inp.thickness / ctx.refThickness);
        }
        var w = 1 + (inp.wastage || 0) / 100;
        var withW = totalKg * w;
        return {
          needed: withW,
          needed_no_wastage: totalKg,
          unit: 'kg',
          breakdown: fmt(areaSqm, 1) + ' m² × ' + ctx.consumption +
            (ctx.refThickness > 0 && inp.thickness ? ' × (' + inp.thickness + '/' + ctx.refThickness + ' mm)' : '') +
            (coats > 1 ? ' × ' + coats + ' coats' : '') +
            (inp.wastage > 0 ? ' × ' + w.toFixed(2) + ' (wastage)' : '') +
            ' = ' + fmt(withW, 1) + ' kg'
        };
      }
    },

    area_litre: {
      id: 'area_litre', label: 'Coverage by area (litre)',
      inputs: ['area', 'areaUnit?', 'coats?', 'wastage?'],
      compute: function (ctx, inp) {
        if (!inp.area || ctx.consumption <= 0) return null;
        var areaSqm = inp.areaUnit === 'sqm' ? inp.area : sqftToSqm(inp.area);
        var coats = inp.coats || ctx.coats || 1;
        var totalL = ctx.consumption * coats * areaSqm;
        var w = 1 + (inp.wastage || 0) / 100;
        var withW = totalL * w;
        return {
          needed: withW,
          needed_no_wastage: totalL,
          unit: 'litre',
          breakdown: fmt(areaSqm, 1) + ' m² × ' + ctx.consumption + ' L/m²' +
            (coats > 1 ? ' × ' + coats + ' coats' : '') +
            (inp.wastage > 0 ? ' × ' + w.toFixed(2) + ' (wastage)' : '') +
            ' = ' + fmt(withW, 1) + ' L'
        };
      }
    },

    area_kg_per_mm: {
      id: 'area_kg_per_mm', label: 'Tile adhesive (kg per mm of bed)',
      inputs: ['area', 'areaUnit?', 'bed_thickness_mm', 'wastage?', 'tile_size?'],
      compute: function (ctx, inp) {
        var bed = parseFloat(inp.bed_thickness_mm) || 0;
        if (!inp.area || !bed || ctx.consumption <= 0) return null;
        var areaSqm = inp.areaUnit === 'sqm' ? inp.area : sqftToSqm(inp.area);
        var totalKg;
        if (ctx.refThickness > 0) {
          totalKg = ctx.consumption * (bed / ctx.refThickness) * areaSqm;
        } else {
          totalKg = ctx.consumption * bed * areaSqm;
        }
        var w = 1 + (inp.wastage || 0) / 100;
        var withW = totalKg * w;
        var warning = null;
        if (ctx.tileSize === 'large_format' && inp.tile_size && inp.tile_size <= 600) {
          warning = 'This adhesive is recommended for tiles >600 mm. For smaller tiles consider interior grade.';
        } else if (ctx.tileSize === 'standard' && inp.tile_size && inp.tile_size > 600) {
          warning = 'This adhesive is for tiles ≤600 mm. For larger tiles consider large-format grade.';
        }
        return {
          needed: withW,
          unit: 'kg',
          warning: warning,
          breakdown: fmt(areaSqm, 1) + ' m² × ' + bed + ' mm × ' + ctx.consumption + ' kg/m²/mm = ' + fmt(withW, 1) + ' kg'
        };
      }
    },

    dosage_per_bag: {
      id: 'dosage_per_bag', label: 'Admixture (per 50 kg cement bag)',
      inputs: ['cement_bags', 'wastage?'],
      compute: function (ctx, inp) {
        if (!inp.cement_bags || ctx.consumption <= 0) return null;
        var n = inp.cement_bags * ctx.consumption;
        var w = 1 + (inp.wastage || 0) / 100;
        var withW = n * w;
        return {
          needed: withW,
          unit: unitFromString(ctx.unit),
          breakdown: inp.cement_bags + ' bag × ' + ctx.consumption + ' ' + (ctx.unit || 'per bag') + ' = ' + fmt(withW, 2) + ' ' + unitFromString(ctx.unit)
        };
      }
    },

    dosage_pct_cement: {
      id: 'dosage_pct_cement', label: 'Admixture (% of cement)',
      inputs: ['cement_bags', 'wastage?'],
      compute: function (ctx, inp) {
        if (!inp.cement_bags || ctx.consumption <= 0) return null;
        var ck = inp.cement_bags * 50;
        var n = ck * (ctx.consumption / 100);
        var w = 1 + (inp.wastage || 0) / 100;
        var withW = n * w;
        return {
          needed: withW,
          unit: unitFromString(ctx.unit),
          breakdown: inp.cement_bags + ' bags × 50 kg × ' + ctx.consumption + '% = ' + fmt(withW, 2) + ' ' + unitFromString(ctx.unit)
        };
      }
    },

    dosage_per_cum: {
      id: 'dosage_per_cum', label: 'Concrete admixture (per m³)',
      inputs: ['concrete_volume_m3', 'wastage?'],
      compute: function (ctx, inp) {
        if (!inp.concrete_volume_m3 || ctx.consumption <= 0) return null;
        var n = inp.concrete_volume_m3 * ctx.consumption;
        var w = 1 + (inp.wastage || 0) / 100;
        var withW = n * w;
        return {
          needed: withW,
          unit: 'kg',
          breakdown: inp.concrete_volume_m3 + ' m³ × ' + ctx.consumption + ' = ' + fmt(withW, 2) + ' kg'
        };
      }
    },

    dosage_dual: {
      id: 'dosage_dual', label: 'Admixture (plaster OR concrete mode)',
      inputs: ['cement_bags', 'dual_mode'],
      compute: function (ctx, inp) {
        if (!inp.cement_bags) return null;
        var gPerBag = inp.dual_mode === 'concrete'
          ? (ctx.maxDosage > 0 ? ctx.maxDosage : 300)
          : (ctx.consumption > 0 ? ctx.consumption : 200);
        var totalKg = (gPerBag * inp.cement_bags) / 1000;
        return {
          needed: totalKg,
          unit: 'kg',
          breakdown: inp.cement_bags + ' bags × ' + gPerBag + ' g/bag (' + (inp.dual_mode || 'plaster') + ') = ' + fmt(totalKg, 2) + ' kg'
        };
      }
    },

    /* JOINT FILL BY VOLUME — rect slots + cyl holes + annular (core-cut around pipe) */
    joint_volume: {
      id: 'joint_volume', label: 'Grout fill (by joint volume)',
      inputs: ['rect_l_mm?', 'rect_w_mm?', 'rect_d_mm?', 'rect_count?',
               'cyl_d_mm?', 'cyl_depth_mm?', 'cyl_count?',
               'core_outer_d_mm?', 'core_inner_d_mm?', 'core_depth_mm?', 'core_count?',
               'wastage?'],
      compute: function (ctx, inp) {
        var density = ctx.consumption > 0 ? ctx.consumption : 1950;
        var totalVolM3 = 0;
        var parts = [];
        // Rectangular pockets/gaps
        if (inp.rect_count > 0 && inp.rect_l_mm > 0 && inp.rect_w_mm > 0 && inp.rect_d_mm > 0) {
          var vRect = (inp.rect_l_mm / 1000) * (inp.rect_w_mm / 1000) * (inp.rect_d_mm / 1000) * inp.rect_count;
          totalVolM3 += vRect;
          parts.push(fmt(vRect * 1000, 2) + ' L rect');
        }
        // Round holes/voids
        if (inp.cyl_count > 0 && inp.cyl_d_mm > 0 && inp.cyl_depth_mm > 0) {
          var r = (inp.cyl_d_mm / 1000) / 2;
          var vCyl = Math.PI * r * r * (inp.cyl_depth_mm / 1000) * inp.cyl_count;
          totalVolM3 += vCyl;
          parts.push(fmt(vCyl * 1000, 2) + ' L round');
        }
        // Annular — pipe through core-cut
        if (inp.core_count > 0 && inp.core_outer_d_mm > 0 && inp.core_inner_d_mm > 0 &&
            inp.core_depth_mm > 0 && inp.core_outer_d_mm > inp.core_inner_d_mm) {
          var rOut = (inp.core_outer_d_mm / 1000) / 2;
          var rIn  = (inp.core_inner_d_mm / 1000) / 2;
          var vAnn = Math.PI * (rOut * rOut - rIn * rIn) * (inp.core_depth_mm / 1000) * inp.core_count;
          totalVolM3 += vAnn;
          parts.push(fmt(vAnn * 1000, 2) + ' L annular');
        }
        if (totalVolM3 <= 0) return null;
        var totalKg = density * totalVolM3;
        var w = 1 + (inp.wastage || 0) / 100;
        var withW = totalKg * w;
        var summary = parts.length > 1 ? '(' + parts.join(' + ') + ') = ' : '';
        return {
          needed: withW,
          unit: 'kg',
          volumeM3: totalVolM3,
          breakdown: summary + fmt(totalVolM3 * 1000, 2) + ' L void × ' + density + ' kg/m³ = ' + fmt(withW, 1) + ' kg'
        };
      }
    },

    joint_volume_linear: {
      id: 'joint_volume_linear', label: 'Grout fill (by linear joint length)',
      inputs: ['joint_length_m', 'wastage?'],
      compute: function (ctx, inp) {
        if (!ctx.jointDims || !inp.joint_length_m) return null;
        var dims = String(ctx.jointDims).split('x');
        var jw = parseFloat(dims[0]) || 10;
        var jd = parseFloat(dims[1]) || 10;
        var volL = jw * jd * inp.joint_length_m / 1000;
        var w = 1 + (inp.wastage || 0) / 100;
        var withW = volL * w;
        return {
          needed: withW,
          unit: 'litre',
          breakdown: jw + ' × ' + jd + ' mm × ' + inp.joint_length_m + ' m = ' + fmt(withW, 2) + ' L'
        };
      }
    },

    joint_sheet: {
      id: 'joint_sheet', label: 'Expansion joint board (sheets)',
      inputs: ['joint_length_m', 'joint_depth_mm?', 'thickness_mm', 'wastage?'],
      compute: function (ctx, inp) {
        var jl = parseFloat(inp.joint_length_m) || 0;
        var thk = parseFloat(inp.thickness_mm) || 0;
        if (jl <= 0 || thk <= 0) return null;

        var SHEET_WIDTH_MM = 1400;
        var SHEET_LENGTH_M = 2.0;
        var coverPerSheet, stripsPerSheet = 0;
        if (inp.joint_depth_mm && inp.joint_depth_mm > 0) {
          stripsPerSheet = Math.floor(SHEET_WIDTH_MM / inp.joint_depth_mm);
          if (stripsPerSheet < 1) stripsPerSheet = 1;
          coverPerSheet = stripsPerSheet * SHEET_LENGTH_M;
        } else {
          coverPerSheet = SHEET_LENGTH_M;
        }
        var w = 1 + (inp.wastage || 0) / 100;
        var sheets = Math.ceil((jl * w) / coverPerSheet);
        if (sheets <= 0) return null;

        var pick = null;
        if (ctx.variants && ctx.variants.length) {
          for (var i = 0; i < ctx.variants.length; i++) {
            var v = ctx.variants[i];
            var m = (v.title || '').match(/(\d+(?:\.\d+)?)\s*mm/i);
            if (m && parseFloat(m[1]) === thk) {
              pick = v; break;
            }
          }
        }

        var out = {
          needed: sheets,
          unit: 'sheet',
          sheets: sheets,
          stripsPerSheet: stripsPerSheet,
          coverPerSheet: coverPerSheet,
          breakdown: stripsPerSheet > 0
            ? stripsPerSheet + ' strips × 2.0 m = ' + fmt(coverPerSheet, 1) + ' m of ' + thk + ' mm joint per sheet → ' + sheets + ' sheet' + (sheets !== 1 ? 's' : '')
            : sheets + ' × ' + thk + ' mm full sheet' + (sheets !== 1 ? 's' : '')
        };
        if (pick) {
          out.packs = [{
            id: pick.id,
            title: thk + ' mm sheet',
            size: 1,
            count: sheets,
            unit_price: pick.price,
            price: pick.price * sheets,
            available: pick.available !== false
          }];
          out.totalPrice = pick.price * sheets;
        }
        return out;
      }
    },

    length_per_kg: {
      id: 'length_per_kg', label: 'Linear sealant (kg per m)',
      inputs: ['joint_length_m', 'wastage?'],
      compute: function (ctx, inp) {
        if (!inp.joint_length_m || ctx.consumption <= 0) return null;
        var w = 1 + (inp.wastage || 0) / 100;
        var needed = inp.joint_length_m * w / ctx.consumption;
        return {
          needed: needed,
          unit: 'kg',
          breakdown: inp.joint_length_m + ' m ÷ ' + ctx.consumption + ' m/kg = ' + fmt(needed, 2) + ' kg'
        };
      }
    },

    length_per_tube: {
      id: 'length_per_tube', label: 'Sealant tubes (cartridges)',
      inputs: ['joint_length_m', 'wastage?'],
      compute: function (ctx, inp) {
        if (!inp.joint_length_m || ctx.consumption <= 0) return null;
        var w = 1 + (inp.wastage || 0) / 100;
        var raw = inp.joint_length_m * w / ctx.consumption;
        var tubes = Math.ceil(raw);
        if (tubes <= 0) return null;
        return {
          needed: tubes,
          unit: 'tube',
          tubes: tubes,
          breakdown: inp.joint_length_m + ' m ÷ ' + ctx.consumption + ' m/tube = ' + tubes + ' × '+(ctx.coverage_value&&ctx.coverage_value<0.5?'350 ml cartridge':'600 ml tube') + (tubes !== 1 ? 's' : ''),
          packs: [{
            title: (ctx.coverage_value&&ctx.coverage_value<0.5?'350 ml cartridge':'600 ml tube'),
            size: 1,
            count: tubes,
            unit_price: null,
            price: null,
            available: true
          }]
        };
      }
    }
  };

  function calc(formulaId, ctx, inputs) {
    var f = formulas[formulaId];
    if (!f || typeof f.compute !== 'function') return null;
    var r = f.compute(ctx, inputs || {});
    if (!r) return null;
    r.formula = formulaId;
    if (!r.packs && r.needed > 0 && (r.unit === 'kg' || r.unit === 'litre')) {
      var rounded = Math.ceil(r.needed * 10) / 10;
      var sizes = normalizePackSizes(ctx.pack_sizes || mapVariantsToPackSizes(ctx.variants));
      if (sizes.length) {
        var combo = packCombo(rounded, sizes);
        if (combo) {
          r.combo = combo;
          r.comboLabel = comboLabel(combo, r.unit);
          r.comboTotal = comboTotal(combo);
          var packsObj = ctx.pack_sizes || mapVariantsToPackSizes(ctx.variants);
          var total = comboPrice(combo, packsObj);
          if (total > 0) r.totalPrice = total;
          r.packs = enrichCombo(combo, packsObj);
        }
      }
    }
    return r;
  }

  function mapVariantsToPackSizes(variants) {
    if (!variants || !variants.length) return null;
    var out = [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      out.push({
        id: v.id,
        size: v.weight_kg,
        weight_unit: 'kg',
        title: v.title,
        price: v.price,
        available: v.available !== false
      });
    }
    return out;
  }

  function enrichCombo(combo, packs) {
    if (!packs || !packs.length) return combo;
    var out = [];
    for (var j = 0; j < combo.length; j++) {
      var x = combo[j];
      var match = null;
      for (var i = 0; i < packs.length; i++) {
        var sz = packs[i].size || packs[i].weight_kg || 0;
        if (sz >= 1000) sz = sz / 1000;
        if (Math.abs(sz - x.size) < 0.011) { match = packs[i]; break; }
      }
      out.push({
        id: match ? match.id : null,
        title: match ? match.title : (x.size + ' kg'),
        size: x.size,
        count: x.count,
        unit_price: match ? match.price : null,
        price: match && match.price ? match.price * x.count : null,
        available: match ? (match.available !== false) : true
      });
    }
    return out;
  }

  window.TTEstimator = {
    version: '0.3.0',
    formulas: formulas,
    normalize: normalize,
    calc: calc,
    packCombo: packCombo,
    normalizePackSizes: normalizePackSizes,
    comboPrice: comboPrice,
    comboLabel: comboLabel,
    comboTotal: comboTotal,
    enrichCombo: enrichCombo,
    mapVariantsToPackSizes: mapVariantsToPackSizes,
    mapLegacyFormula: mapLegacyFormula,
    inr: inr,
    fmt: fmt,
    sqftToSqm: sqftToSqm
  };
})();
